module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cf-alert-wrap cf-hide"
  }, [(_vm.show && _vm.success) ? _c('p', {
    staticClass: "cf-alert cf-alert-success"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.message) + "\n\t")]) : _vm._e(), _vm._v(" "), (_vm.show && !_vm.success) ? _c('p', {
    staticClass: "cf-alert cf-alert-warning"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.message) + "\n\t")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2ae9c58"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Elements/Status/Status.vue
// module id = 234
// module chunks = 1